import { createSelector } from 'reselect';
import { AppState } from 'src/store/state';
import { RestorePasswordPageState } from './state';
import { plainToClassFromExist } from 'class-transformer';
import { ServerError } from '../../../entities/server-errors';
import { User } from '../../../entities/user';
import { DTOGroup } from '../../../enums/dto-group';

const selectFeature = (state: AppState): RestorePasswordPageState => state.pages.restorePassword;

export class RestorePasswordPageSelectors {
  public static isSending = createSelector(
    selectFeature,
    (state) => state.isSending
  );

  public static error = createSelector(
    selectFeature,
    (state) => plainToClassFromExist(
      new ServerError<User>(User),
      state.error,
      {
        groups: [DTOGroup.MAIN],
        strategy: 'excludeAll'
      }
    ) as ServerError<User>
  );
}
